import React, { useEffect, useState } from 'react'
import styles from './ImageReport.module.scss'
import Button from '../../components/Button'
import { transformRes } from './utils'
import usStateAll from '../../components/Map/usStatesAll'
import { ToastContainer, toast } from 'react-toastify'
import { parseISO, format } from 'date-fns'
import Table from '../../components/Table/Table'
import LoadingState from '../../components/Loader'

const openUrls = function (urls) {
  let delay = 0
  urls.forEach((url, index) => {
    setTimeout(() => {
      window.open(
        `${url}?index=${index}`,
        '_blank',
        `width=${1300}px,height=${840}px`
      )
    }, delay)
    delay += 15000
  })
}

const generateUrls = function (BASE_URL, disease) {
  const stateUrls = usStateAll.map((state) => {
    return `${BASE_URL}HeatMapNew/${disease}/state/${state.value}`
  })
  const updatedStateUrls = [
    `${BASE_URL}HeatMapNew/${disease}/NAT`,
    ...stateUrls,
  ]
  // return updatedStateUrls.slice(0, 1)
  return updatedStateUrls
}

const tableColumns = [
  // { id: 0, label: 'Sl.', accessor: 'serial' },
  { id: 1, label: 'File Name', accessor: 'filename' },
  { id: 2, label: 'Created Date', accessor: 'createdDate', hidden: true },
  { id: 3, label: 'Last Modified Date', accessor: 'lastModifiedDate' },
  {
    id: 4,
    label: 'Status of Last Run',
    accessor: 'status',
    render: (value) => (
      <span className={value === 'SUCCESS' ? styles.success : styles.failure}>
        {value}
      </span>
    ),
  },
  {
    id: 5,
    label: 'Action',
    accessor: 'action',
    render: (value, row) => {
      return (
        <Button
          // disabled={row.status === 'SUCCESS'}
          className={styles.regenerate_btn}
          onClick={() => handleRegenerateClick(row.filename)}
        >
          Regenerate
        </Button>
      )
    },
  },
]

const handleRegenerateClick = (file) => {
  const disease = file.split('_')[0]
  const BASE_URL = process.env.REACT_APP_UI_HOME
  const url = file.includes('nat') || file.includes('NAT')
    ? `${BASE_URL}HeatMapNew/${disease}/NAT`
    : `${BASE_URL}HeatMapNew/${disease}/state/${
        file.split('_').at(-1).split('.')[0]
      }`

  window.open(`${url}?index=${0}`, '_blank', 'width=1300,height=840')
}

const ImageReport = ({ label, show }) => {
  const BASE_URL = process.env.REACT_APP_UI_HOME
  const BACKEND_URL = process.env.REACT_APP_BACKEND_BASE_URL

  const [loading, setLoading] = useState(false)
  const [fetching, setFetching] = useState(false)
  const [imageData, setImageData] = useState([])
  const [lastRun, setLastRun] = useState()

  //state used to track proccessed images
  const [processedCount, setProcessedCount] = useState(0)

  useEffect(() => {
    if (!show) return
    let broadcastChannel = new BroadcastChannel(`map_channel`)
    broadcastChannel.onmessage = (event) => {
      setProcessedCount(event.data.processed)
      if (event.data.status) {
        toast.success(event.data.message)
      } else {
        toast.error(event.data.message)
      }
      if (event.data.processed === 52) {
        setLoading(false)
      }
    }
    return () => {
      broadcastChannel.onmessage = null
    }
  }, [show])

  //fetch the previous uploaded images status for that particular disease
  useEffect(() => {
    setFetching(true)
    const fetchImagesStatus = async () => {
      try {
        const response = await fetch(
          `${BACKEND_URL}/getimage?disease=${label.toUpperCase()}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'text/plain',
              requester: JSON.stringify(
                window.localStorage.getItem('requester')
              ),
            },
            credentials: 'include',
          }
        )
        const res = await response.json()
        const latestObject = res.reduce((max, current) => {
          const maxDate = new Date(max.LastModified)
          const currentDate = new Date(current.LastModified)

          return currentDate > maxDate ? current : max
        }, res[0])
        const transformedResult = transformRes(res, latestObject.LastModified)
        setLastRun(latestObject.LastModified)
        setImageData(transformedResult)
      } catch (er) {
        console.log(er)
      } finally {
        setFetching(false)
      }
    }
    fetchImagesStatus()
  }, [loading])

  if (!show) {
    return null
  }

  const handleGenerateClick = (diseaseType) => {
    setLoading(true)
    const URLS = generateUrls(BASE_URL, diseaseType)
    openUrls(URLS)
  }

  return (
    <section className={styles.base}>
      <header className={styles.header}>
        <div>
          <h3>{label} image generation </h3>
          <small>
            {lastRun &&
              `Last successful trigger - ${format(
                parseISO(lastRun),
                'EEE dd MMM yyyy, hh a'
              )} `}

            {loading && (
              <span className={styles.feedback}>
                ({processedCount} of 52 completed)
              </span>
            )}
          </small>
        </div>
        <div className={styles.btn_container}>
          {loading && (
            <Button
              className={styles.stop_btn}
              onClick={() => {
                window.location.reload()
              }}
            >
              Stop
            </Button>
          )}
          <Button
            disabled={loading}
            className={styles.regenerate_all_btn}
            onClick={() => handleGenerateClick(label.toLowerCase())}
          >
            {loading ? 'Generating...' : `Generate ${label}`}
          </Button>
        </div>
      </header>
      {<LoadingState loading={fetching} />}
      {!fetching && imageData?.length > 0 && (
        <div>
          <Table cols={tableColumns} rows={imageData} />
        </div>
      )}
      {!fetching && imageData?.length === 0 && <p>No data found</p>}
      <div>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </section>
  )
}

export default ImageReport
